/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  CurveLPTokensPAPBaseCache,
  CurveLPTokensPAPBaseCacheInterface,
} from "../CurveLPTokensPAPBaseCache";

const _abi = [
  {
    inputs: [],
    name: "EmptyWETHAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNumberOfCoinsInPool",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolForLPTokenNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenAlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedPoolWithTwoLPs",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroPrice",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "LPTokenEnabled",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isLPToken",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lpTokenPool",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isMeta",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class CurveLPTokensPAPBaseCache__factory {
  static readonly abi = _abi;
  static createInterface(): CurveLPTokensPAPBaseCacheInterface {
    return new utils.Interface(_abi) as CurveLPTokensPAPBaseCacheInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveLPTokensPAPBaseCache {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveLPTokensPAPBaseCache;
  }
}
